import React from "react";
import { Col, Row } from "reactstrap";
import LayoutStoreHome from "../../layouts/LayoutStoreHome";
import data from "../../data/featured.json";
import ProductCorousel from "../../components/product/ProductCorousel";
import FeaturedProduct from "../../components/sections/FeaturedProduct";
import Collection from "../../components/sections/Collection";
import Brands from "../../components/sections/Brands";

const StoreMain = () => {
  return (
    <LayoutStoreHome>
      {/**Collection */}
      <Collection />

      {/**The latest */}
      <Row className="section">
        <Col sm={12} className="mb-4">
          <h3 className="text-medium text-bold">{data.featured.title}</h3>
        </Col>
        <ProductCorousel />
      </Row>

      {/**Featured sneaker */}
      <FeaturedProduct />

      {/** Brands you love */}
      <Brands />
      {/**The latest */}
      <Row className="section">
        <Col sm={12}>
          <h3 className="text-bold text-medium">{data.featured2.title}</h3>
        </Col>
        <ProductCorousel />
      </Row>
    </LayoutStoreHome>
  );
};

export default StoreMain;
